import axios from 'axios';
import { config } from '../config/env';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add any auth tokens or other headers here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      // Handle unauthorized access
      console.error('Unauthorized access');
    }
    return Promise.reject(error);
  }
);

// API endpoints
export const apiEndpoints = {
  // Get available dates
  getDates: () => api.get('/user-panel/get-dates'),
  
  // Get slots for a specific date
  getSlots: (dateId: string) => api.get(`/user-panel/get-slots/${dateId}`),
  
  // Start session for a slot-consultant mapping
  startSession: (slotConsultantMappingId: string) => 
    api.get(`/user-panel/start-session/${slotConsultantMappingId}`),
  
  // Book appointment
  bookAppointment: (data: any) => api.post('/user-panel/book-appointment', data),
  
  // Custom payment
  customPayment: (data: any) => api.post('/user-panel/custom-payment', data),
};

export default api;
